import React from 'react';
import { LabelValueCell } from '../../../components/table-2.0';
import { formatAddonsList } from '../../../utils/formatting';

export default function CellPricingOptionAndAddOns({ pricingOption, addOns }) {
  const addOnLabel = formatAddonsList({ addOns });

  return <LabelValueCell label={pricingOption?.label} value={addOnLabel} />;
}
